import NavItem from './NavItem'
import List from '@mui/material/List';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { useSelector, useDispatch } from "react-redux";
import { MENU_OPEN } from '../../../../constants/actions'
import { useEffect } from 'react'
import { useLocation } from "react-router";
import { childListButtonStyle, listButtonStyle } from "../constant";
import { groupBy } from 'mixin/general';
import NavGroup from './NavGroup';
import useListQuery from 'hooks/useListQuery';
import pathMenus from 'menu-items/pathMenus';

const MenuList = () => {
    const dispatch = useDispatch()
    const menuOpen = useSelector((state:any) => state.customization.isOpen)
    const leftDrawerOpen = useSelector((state:any) => state.customization.opened)
    const location = useLocation()
    const { listQuery, setListQuery } = useListQuery()

    const handleClick = (id:string, childId:string) => {
        setListQuery({...listQuery, limit: 10, offset: 0, page: 1})
        dispatch({ type: MENU_OPEN, id: [id, childId] })
        console.log('menu open', menuOpen)
    }

    useEffect(() => {
        const pathName = location.pathname
        const menus = global?.session?.role?.menu_access
        const dbMenus = menus?.map((menu: any) => menu?.url) ?? []
        const allowedPathMenus = pathMenus?.filter((el: any) => dbMenus.indexOf(el?.url_id) !== -1)
        const matchedPathMenu = allowedPathMenus
            ?.filter((menu: any) => {
                const urlPath = menu?.url_path as string
                if (!urlPath) return false
                const prefix = urlPath.endsWith('/') ? urlPath : `${urlPath}/`
                return pathName === urlPath || pathName.startsWith(prefix)
            })
            ?.sort((a: any, b: any) => (b?.url_path?.length ?? 0) - (a?.url_path?.length ?? 0))[0]

        const selectedMenu = menus?.find((a: any) => a.url === matchedPathMenu?.url_id)
            || menus
                ?.filter((a: any) => a.url === pathName || (a.url && pathName.startsWith(`${a.url}/`)))
                ?.sort((a: any, b: any) => (b.url?.length ?? 0) - (a.url?.length ?? 0))[0]

        if (selectedMenu?.id) {
            handleClick(selectedMenu.id, '0')
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <PerfectScrollbar
            component="div"
            style={{
                position: 'relative',
                height: 'calc(100vh - 5rem)',
                padding: leftDrawerOpen ? '16px' : 0,
                display: leftDrawerOpen ? 'flex' : 'none',
                flexDirection: 'column',
                zIndex: 1,
                background: "rgb(var(--theme-bg-base))"
            }}
        >   
            <List sx={{p: 0}}>
                {
                    groupBy(global?.session?.role?.menu_access?.filter((menu: any) => {
                        return menu?.group?.toLowerCase() !== 'agent' && menu?.group?.toLowerCase() !== 'supervisor' &&  menu?.group?.toLowerCase() !== 'pejabat'
                    }), 'group')?.map((item:any, n:number) => {
                        // console.log(item.type, 'check item type')
                        if (item.type === 'collapse') return <NavGroup item={item} listButtonStyle={listButtonStyle} childListButtonStyle={childListButtonStyle} handleClick={handleClick} selected={menuOpen} />
                        else if (item.type === 'group') return <NavItem item={item} listButtonStyle={listButtonStyle} handleClick={handleClick} selected={menuOpen} />
                        return <NavItem item={item} listButtonStyle={listButtonStyle} handleClick={handleClick} selected={menuOpen} />
                    })
                }
            </List>
            
            {/* {menuItems.items.map((item:any) => {
                return (
                    <>
                        <List
                            sx={{
                                p: 0
                            }}
                            subheader={
                                item?.title ? 
                                    <ListSubheader component="div" id="nested-list-subheader" sx={subHeaderStyle}>
                                        {item?.title} <br />
                                        <small className="text-gray-500">{item?.caption}</small>
                                    </ListSubheader> : null
                            }
                        >
                            {
                                item.children.map((child:any) => {
                                    if (child.type === 'collapse') return <NavGroup item={child} listButtonStyle={listButtonStyle} childListButtonStyle={childListButtonStyle} handleClick={handleClick} selected={menuOpen} />
                                    else if (child.type === 'group') return <NavItem item={child} listButtonStyle={listButtonStyle} handleClick={handleClick} selected={menuOpen} />
                                    else return <NavItem item={child} listButtonStyle={listButtonStyle} handleClick={handleClick} selected={menuOpen} />
                                })
                            }
                        </List>
                        <Divider light sx={{ my: 2 }} />
                    </>
                )
            })} */}
        </PerfectScrollbar>
    )
}

export default MenuList